export const DEFAULT_RISK_MATRIX = {
    enabled: true,
    thresholds: {
        low: {
            max: 9,
            color: 'green',
            label: 'Asset OK',
            action: 'Normal maintenance schedule',
        },
        medium: {
            max: 12,
            color: 'yellow',
            label: 'Fix asset on failure',
            action: 'Monitor and repair when convenient',
        },
        high: {
            max: 16,
            color: 'orange',
            label: 'Further investigation required',
            action: 'Further investigation required before refurbishment or replacement work recommended',
        },
        critical: {
            max: 25,
            color: 'red',
            label: 'Refurbishment or replacement',
            action: 'Asset considered for refurbishment or replacement work',
        },
    },
};
